// Fields, defaults, and library info for this section. The editor builds its form from `fields`.
const definition = {
  order: 110,
  type: "marquee",
  name: "Scrolling words",
  category: "Content",
  description: "A moving line of words. Separate each word with a comma.",
  defaultSettings: {
    words: "Smartphones, Audio, Tablets, Wearables, Accessories, Chargers",
  },
  fields: [
    { key: "words", label: "Words", type: "textarea", placeholder: "Smartphones, Audio, Tablets" },
  ],
};

export default definition;
